import {
  LOAD_DEVICE_RESOURCES,
  unloadDeviceResourcesAction,
} from "fleet/redux-store/ui-state/device-resources/actions";
import { resourcesSelector } from "fleet/redux-store/ui-state/device-resources/selectors";
import { DeviceDetailsPage } from "fleet/view/device/details";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { applicationsSelector } from "redux-store/applications/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state, props) {
  const {
    device,
    deviceId,
    deviceStatus,
    storesLoaded: parentStoresLoaded,
  } = props;

  const storesLoaded =
    storesReady(state.global.applications) && parentStoresLoaded;

  return {
    device,
    deviceId,
    deviceStatus,
    storesLoaded,
    applications: applicationsSelector(state),
    resources: resourcesSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadDeviceResources: (deviceId, type, hours) => {
      return createPromiseApiAction(dispatch, LOAD_DEVICE_RESOURCES, [
        deviceId,
        type,
        hours,
      ]);
    },
    unloadDeviceResources: () => {
      dispatch(unloadDeviceResourcesAction);
    },
  };
}

const ConnectedDeviceDetailsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceDetailsPage);

export { ConnectedDeviceDetailsPage };
